import userActions from './users'
import jsonActions from './json'
import collectionActions from './collections'

export default {
  ...userActions,
  ...jsonActions,
  ...collectionActions,
}
